export const useNavigation = () => ({
    isReady: () => true,
    getCurrentRoute: () => undefined,
});

export const useNavigationState = (selector) => selector?.({ routes: [] });

/* eslint-disable react/prop-types */
export const NavigationContainer = ({ children }) => children ?? null;

export default {
    useNavigation,
    useNavigationState,
    NavigationContainer,
};
